// extracted by mini-css-extract-plugin
module.exports = {"legacy-panel":"_2IRN9yFjF5_ot0y2ls_JNq","legacy-panel--gray":"b4D4l1Zy5htaave7g3L19","legacy-panel--large":"_2_dcw7icd3aYRYAah5_rwB"};